/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserManagementCreateUserRequest } from "../models/UserManagementCreateUserRequest";
import type { UserManagementCreateUserResponseApiRespoonse } from "../models/UserManagementCreateUserResponseApiRespoonse";
import type { UserManagementDeletedUserRequest } from "../models/UserManagementDeletedUserRequest";
import type { UserManagementDeletedUserResponseApiRespoonse } from "../models/UserManagementDeletedUserResponseApiRespoonse";
import type { UserManagementForgotPasswordRequest } from "../models/UserManagementForgotPasswordRequest";
import type { UserManagementForgotPasswordResponseApiRespoonse } from "../models/UserManagementForgotPasswordResponseApiRespoonse";
import type { UserManagementGetUserByTokenRequest } from "../models/UserManagementGetUserByTokenRequest";
import type { UserManagementGetUserByTokenResponseApiRespoonse } from "../models/UserManagementGetUserByTokenResponseApiRespoonse";
import type { UserManagementListGroupRequest } from "../models/UserManagementListGroupRequest";
import type { UserManagementListGroupResponseApiRespoonse } from "../models/UserManagementListGroupResponseApiRespoonse";
import type { UserManagementListUserRequest } from "../models/UserManagementListUserRequest";
import type { UserManagementListUserResponseApiRespoonse } from "../models/UserManagementListUserResponseApiRespoonse";
import type { UserManagementRegistPasswordRequest } from "../models/UserManagementRegistPasswordRequest";
import type { UserManagementRegistPasswordResponseApiRespoonse } from "../models/UserManagementRegistPasswordResponseApiRespoonse";
import type { UserManagementResetPasswordRequest } from "../models/UserManagementResetPasswordRequest";
import type { UserManagementResetPasswordResponseApiRespoonse } from "../models/UserManagementResetPasswordResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class UserManagerService {
  /**
   * Get list user
   * @param requestBody
   * @returns UserManagementListUserResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminUser(
    requestBody: UserManagementListUserRequest
  ): CancelablePromise<UserManagementListUserResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/user",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * create user
   * @param requestBody
   * @returns UserManagementCreateUserResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminUserCreate(
    requestBody: UserManagementCreateUserRequest
  ): CancelablePromise<UserManagementCreateUserResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/user/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * deleted user
   * @param requestBody
   * @returns UserManagementDeletedUserResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminUserDelete(
    requestBody: UserManagementDeletedUserRequest
  ): CancelablePromise<UserManagementDeletedUserResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/admin/user/delete",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get list group
   * @param requestBody
   * @returns UserManagementListGroupResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminUserGroups(
    requestBody: UserManagementListGroupRequest
  ): CancelablePromise<UserManagementListGroupResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/user/groups",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * find user by token
   * @param requestBody
   * @returns UserManagementGetUserByTokenResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminUserInvitedUser(
    requestBody: UserManagementGetUserByTokenRequest
  ): CancelablePromise<UserManagementGetUserByTokenResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/user/invited-user",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * regist password by token
   * @param requestBody
   * @returns UserManagementRegistPasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminUserRegistPassword(
    requestBody: UserManagementRegistPasswordRequest
  ): CancelablePromise<UserManagementRegistPasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/user/regist-password",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Forgot password by token
   * @param requestBody
   * @returns UserManagementForgotPasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminForgotPassword(
    requestBody: UserManagementForgotPasswordRequest
  ): CancelablePromise<UserManagementForgotPasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/admin/forgot-password",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Reset password by token
   * @param requestBody
   * @returns UserManagementResetPasswordResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static adminResetPassword(
    requestBody: UserManagementResetPasswordRequest
  ): CancelablePromise<UserManagementResetPasswordResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/admin/reset-password",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
